var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"rsl-fixed-height-external"},[_c('v-container',[_vm._v(" Form completed, thank you for your time. ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }